<template>
    <div class="upcoming-timeline">
        <h6 class="upcoming-timeline-title">Coureurs attendus au point</h6>

        <div class="upcoming-timeline-track">
            <div v-for="(step, index) in steps" :key="step.hours" class="upcoming-timeline-step">
                <div class="upcoming-timeline-node">
                    <span class="upcoming-timeline-count">{{ step.count }}</span>
                </div>
                <div class="upcoming-timeline-label">d'ici {{ step.hours }}h</div>
                <div v-if="index < steps.length - 1" class="upcoming-timeline-connector" aria-hidden="true"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['point'],
    computed: {
        coureurs() {
            console.log(this.point);
            if (!this.point || !this.point) {
                return [];
            }
            let coureurs = [];
            for (let i = 0; i < this.point.length; i++) {

                coureurs = [...coureurs, ...this.point[i].remaining_by_timestamp];
            }
            return coureurs;


        },
        steps() {
            const hoursList = [0.5, 1, 3];
            const now = Math.floor(Date.now() / 1000);
            if (!this.coureurs) {
                return hoursList.map(hours => ({ hours, count: 0 }));
            }
            return hoursList.map(hours => ({
                hours,
                count: this.coureurs.filter(
                    c => c.timestamp && c.timestamp <= now + hours * 3600
                ).length,
            }));
        },
    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
.upcoming-timeline {

    margin: 1rem;
    padding: 10px;
    background-color: #f8f9fa;
    border-radius: 5px;
    border: 1px solid #dbe0e6;
}

.upcoming-timeline-title {
    margin-bottom: 0.75rem;
    font-size: 0.9rem;
    color: #495057;
}

.upcoming-timeline-track {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.upcoming-timeline-step {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 0;
}

.upcoming-timeline-node {
    width: 55px;
    height: 55px;
    border-radius: 20px;
    background-color: white;
    border: 3px solid #0143bd;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
}

.upcoming-timeline-count {
    font-weight: bold;
    font-size: 1.1rem;
    color: #0143bd;
}

.upcoming-timeline-label {
    margin-top: 0.5rem;
    font-size: 0.8rem;
    font-weight: 600;
    color: #495057;
    text-align: center;
}

.upcoming-timeline-connector {
    position: absolute;
    top: 24px;
    left: calc(50% + 24px);
    right: calc(-50% + 24px);
    height: 3px;
    background-color: #0143bd;
    opacity: 0.35;
    z-index: 0;
}
</style>
